export let optionProps = {
    key: 0,
    id: 0,
    option_name: '',
    extra_charge: 0,
    image: ''
}

export let qualityItemProps = {
    key: 0,
    id: 0,
    quality_point: ''
}

export let subProcessListProps = {
    key: 0,
    id: 0,
    default_choice: true,
    process_name: ''
}

export let dataProps = {
    id: 0,
    process_name: '', 
    is_cut_order_generated_at_this_stage: false,
    print_instruction_image_with_work_order: false,
    instruction_image: '',
    intructions: '',
    is_piece_rate_approval_required: false,
    is_extra_chargeable: false,
    extra_charge: 0,  
    production_capacity_parameter: false,
    default_choice: true,
    alteration_process: false,
    transfer_to_factory_at_this_stage: false,
    restart_this_process_after_trial: false,
    trial_after_this_process: true,
    option_list: [JSON.parse(JSON.stringify(optionProps))],
    deleted_option_list_items: [],
    category_list: [],
    quality_point_list: [JSON.parse(JSON.stringify(qualityItemProps))],
    deleted_quality_point_list_items: [],
    enable_customer_notification_on_start: false,
    enable_customer_notification_on_finish: false,
    can_add_as_add_on: false,
    sub_process_allowed: false,
    sub_process_list: [JSON.parse(JSON.stringify(subProcessListProps))],
    delete_sub_process_list_items: []
}


// WEBPACK FOOTER //
// ./src/store/modules/productionStage/properties.js